import { connect } from 'react-redux'
import at from 'lodash/at'

import QAWorkOrderCard from '../../components/qa-work-orders/qa-work-order-card'

import { submitQAWorkOrder, deleteQAWorkOrder } from '../../actions/qa-work-orders'

function mapStateToProps (state, ownProps) {
  const qaWorkOrder = state.qaWorkOrders[ownProps.qaWorkOrderId]

  if (!qaWorkOrder) return {}

  const location = state.locations[qaWorkOrder.location]
  const accountManagers = at(state.users, location.accountManagers || [])

  return {
    qaWorkOrder,
    location,
    accountManagers
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.qaWorkOrderId

  return {
    onSubmitForApproval () {
      dispatch(submitQAWorkOrder(id))
    },

    onDelete () {
      if (confirm('Are you sure you want to delete this QA Work Order?')) {
        dispatch(deleteQAWorkOrder(id))
      }
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QAWorkOrderCard)



// WEBPACK FOOTER //
// ./src/containers/qa-work-orders/qa-work-order-card-container.js